import { customElement } from 'lit/decorators.js';
import {LitElement} from 'lit';
import {FormValidationMixin} from "@/components/mixins/form-validation-mixin";
import {SbkLabelMixin} from "@/components/label/label-mixin";
import {FormControlDependencyMixin} from "@/components/form-control-dependency/form-control-dependency-mixin";
import {query} from "lit/decorators/query.js";
// @ts-expect-error Could not find a declaration file for module
import ClassicEditor from '@brosua/ckeditor5-simple-custom-build'
import "@/components/rte/rte.scss";



/**
 * An example element.
 *
 * @slot - This element has a slot
 */
@customElement('sbk-rte')
export class SbkRte extends FormControlDependencyMixin(FormValidationMixin(SbkLabelMixin(LitElement))) {

    @query('textarea')
    _textarea?: HTMLTextAreaElement;

    firstUpdated() {
        ClassicEditor.create(this._textarea)
    }

    createRenderRoot() {
        return this;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'sbk-rte': SbkRte;
    }

}

